var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipseComplete1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.4999,
    cy: 50.4996,
    r: 44.1666,
    stroke: "#FA5A7D",
    strokeWidth: 11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseComplete1);
export default __webpack_public_path__ + "static/media/ellipseComplete1.dd5e19acda1521c1983900be17ee285c.svg";
export { ForwardRef as ReactComponent };